import React from "react";
import { ReactComponent as AmericanExpress } from "assets/svgs/americanexpress.svg";
import { ReactComponent as Maestro } from "assets/svgs/maestro.svg";
import { ReactComponent as MasterCard } from "assets/svgs/mastercard.svg";
import { ReactComponent as Visa } from "assets/svgs/visa.svg";
import { ReactComponent as Paypal } from "assets/svgs/paypal.svg";

const PaymentIcon = ({ brand }) => {
	switch (brand?.toLowerCase()) {
		case "american_express":
		case "americanexpress":
			return <AmericanExpress role="presentation" aria-hidden="true" />;
		case "visa":
			return <Visa role="presentation" aria-hidden="true" />;
		case "mastercard":
			return <MasterCard role="presentation" aria-hidden="true" />;
		case "maestro":
			return <Maestro role="presentation" aria-hidden="true" />;
		case "paypal":
			return <Paypal role="presentation" aria-hidden="true" />;
		default:
			return null;
	}
};

export default PaymentIcon;